export enum AttachmentType {
  image = 'image',
  youtube = 'youtube',
  model = 'model',
  thumbnail = 'thumbnail',
  zip = 'zip',
  other = 'other',
}

export enum AttachmentParentType {
  POST = 'post',
  PROJECT_MAKE = 'projectMake',
  PROJECT_GROUP = 'projectGroup',
  CNC_MODEL = 'cncModel',
  BANNER = 'banner',
}

export enum IAttachmentCategory {
  postMedia = 'postMedia',
  postModel = 'postModel',
  postThumbnail = 'postThumbnail',
  postZip = 'postZip',
  // Backend-generated bundle consumed only by the Redline HMI — never shown in
  // the web UI (see filterAttachments in redux/post/post.utils.ts).
  redlineHmiProjectZip = 'redlineHmiProjectZip',
  projectMakeImages = 'projectMakeImages',
  projectGroupThumbnail = 'projectGroupThumbnail',
  projectGroupCover = 'projectGroupCover',
  projectGroupZip = 'projectGroupZip',
  cncModelPicture = 'cncModelPicture',
  bannerDesktop = 'bannerDesktop',
  bannerMobile = 'bannerMobile',
}

export type IAttachment = {
  _id: string;
  parentId: string;
  parentType: AttachmentParentType;
  fileName: string;
  user: string;
  resourcePath: string;
  url: string;
  fileSize: number;
  fileHash: string;
  resourceType: AttachmentType;
  category: IAttachmentCategory;
  downloadCount: number;
  createdAt: string;
  updatedAt: string;
};

export interface IGetPreSignedUploadUrlRequest {
  attachments: {
    parentId: string;
    parentType: AttachmentParentType;
    category: IAttachmentCategory;
    fileName: string;
    fileHash: string;
    fileSize: number;
    resourceType: AttachmentType;
    controller?: string;
  }[];
}

export interface IGetPreSignedUploadUrlResponse {
  signedUrl: string | null;
  attachmentId: string | null;
  duplicate: boolean;
  message: string;
  fileHash: string;
}
